import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const ContainerWithPlaceHolder = styled(Grid)`
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${getCloudflareImageUrl({
    src: getStaticUrl('sankey_placeholder.png'),
  })});
`;

export const SubSectionHeader = styled('h3')`
  ${({ theme }) => theme.typography.baseStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px;

  ${media.lgUp`
    color: ${(props) => props.theme.color.white};
  `}
`;
export const HeaderGrid = styled(Grid)`
  ${SubSectionHeader} {
    margin: 0;
  }
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const Space = styled.div`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;
